import React, { useContext, useState, useEffect } from 'react';
import {
  Modal,
  Form,
  Typography,
  Row,
  Col,
  Divider,
  InputNumber,
  Switch,
  Space,
  message,
} from 'antd';
import { useIntl } from 'react-intl';
import { StoreContext } from '../store/index';
import { fetchUserByEmail } from '../profile/api';
import { getDateFromTimestamp } from '../utils';

function TokenPaymentModal({
  shift,
  playerEmail,
  visible,
  onClose,
  onConfirm,
}) {
  const store = useContext(StoreContext);
  const {
    user: [user],
  } = store;
  const { formatMessage } = useIntl();
  const { Text } = Typography;

  const {
    startDate,
    placeName,
    address,
    placeSport,
    totalPlayers,
    localTeam,
    price,
  } = shift;

  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);
  const [player, setPlayer] = useState(false);

  useEffect(() => {
    fetchUserByEmail(playerEmail, setLoading).then(data => setPlayer(data[0]));
  }, []);

  const handlePayButton = async values => {
    onConfirm();
    onClose();
  };
  const onFinishFailed = values => {};

  return (
    <Modal
      title={formatMessage({ id: 'shifts.actions.pay' })}
      open={visible}
      onOk={handlePayButton}
      okButtonProps={{ loading: loading }}
      okText="Pagar"
      onCancel={onClose}>
      <Row justify="center" style={{ margin: '4px 0px', paddingRight: '16px' }}>
        <Text>{`Credito: ${player?.tokens} €`}</Text>
      </Row>
      <Row justify="center" style={{ margin: '4px 0px', paddingRight: '16px' }}>
        <Text type="danger">{`Precio: ${price} €`}</Text>
      </Row>
      <Divider />
      <Row justify="center" style={{ margin: '4px 0px', paddingRight: '16px' }}>
        <Text type={(player?.tokens || 0) - price > 0 ? 'success' : 'danger'}>
          {`${(player?.tokens || 0) - price} €`}
        </Text>
      </Row>
      <Divider />
      Puedes acreditar dinero antes de cada partido.
    </Modal>
  );
}

export default TokenPaymentModal;
